import { combineReducers } from 'redux';

import seo from './seo';
import { ratesGraph } from './ratesGraph';
import convertor from './convertor';
import banks from './banks';
import currency from './currency';
import convertorBanks from './convertorBanks';
import convertorCurrenciesCrossRates from './convertorCurrenciesCrossRates';
import convertorCurrenciesInfo from './convertorCurrenciesInfo';
import convertorCurrencyRates from './convertorCurrencyRates';
import convertorExchangeRateDynamics from './convertorExchangeRateDynamics';
import convertorRatesGraph from './convertorRatesGraph';
import convertorCurrencies from './convertorCurrencies';
import routerAdditionalData from './routerAdditionalData';
import exchangers from './exchangers';
import currenciesAllTypesRates from './currenciesAllTypesRates';
import blogs from './blogs';
import forexCompanies from './forexCompanies';
import forexProducts from './forexProducts';
import convertorLinks from './convertorLinks';
import cardsRates from './cardsRates';

const rootReducer = combineReducers({
  seo,
  ratesGraph,
  convertor,
  banks,
  currency,
  convertorBanks,
  convertorCurrenciesCrossRates,
  convertorCurrenciesInfo,
  convertorCurrencyRates,
  convertorExchangeRateDynamics,
  convertorRatesGraph,
  convertorCurrencies,
  routerAdditionalData,
  exchangers,
  currenciesAllTypesRates,
  blogs,
  forexCompanies,
  forexProducts,
  convertorLinks,
  cardsRates,
});

export default rootReducer;
